import * as MallApiService from '../services/api/requests/Mall'

// get all malls
export const doGetAllMalls = async ({
  setMalls = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  await MallApiService.getAllMalls()
    .then(response => {
      setMalls(response.data)
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// get all cms malls
export const doGetAllCMSMalls = async ({
  errorsObj,
  setCMSMalls = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  await MallApiService.getAllCMSMalls()
    .then(response => {
      setCMSMalls(response.data)
      onSuccess(response)
    })
    .catch(error => {
      onError({ errors: { ...errorsObj, cmsMalls: error.message } })
    })
}

// get mall modal data
export const doGetMallModalData = async ({ viewId }) => {
  let mallModalData = {}
  const { data: mallList } = await MallApiService.getAllCMSMalls()
  const filteredMall = mallList.filter(
    ({ id, slugName }) => `${slugName || id}` === `${viewId}`,
  )
  mallModalData = filteredMall[0] || null
  if (!mallModalData) {
    const [firstMall] = mallList
    return firstMall
  }
  return mallModalData
}
